// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ABOUT_ME_CHANGE_PROFILE = "Uprav profil";
export const ABOUT_ME_FOLLOWERS_count = "Ob\u013e\u00fabili si ma (%(count)s)";
export const ABOUT_ME_FOLLOWING_count = "Moji ob\u013e\u00faben\u00ed (%(count)s)";
export const ABOUT_ME_GROUPS_count = "Skup\u00edn (%(count)s)";
export const ABOUT_ME_MORE_ABOUT_ME = "viac o mne";
export const ABOUT_ME_PRODUCTS_count = "Inzer\u00e1ty (%(count)s)";
export const BEFORE_BIRTH_1 = "E\u0161te";
export const BEFORE_BIRTH_2 = "do p\u00f4rodu.";
export const CHANGE = "Zme\u0148";
export const number_DAYS = ["%(number)s de\u0148", "%(number)s dni", "%(number)s dn\u00ed"];
export const number_YEARS = ["%(number)s rok", "%(number)s roky", "%(number)s rokov"];
export const PROFILE_REGISTERED_ON_date = "Na Kon\u00edku od %(date)s";
export const PROFILE_SUMMARY__IN_num_PREGNANCY_WEEK = "v %(num)s. t\u00fd\u017edni tehotenstva";
export const PROFILE_SUMMARY__name_IS_in_num_pregnancy_week = "%(name)s je %(in_num_pregnancy_week)s";
export const PROFILE_VISIT_GROUP_group = "Po\u010f do skupiny %(group)s";
export const SEND_INTERNAL_POST = "Nap\u00ed\u0161 jej intern\u00fa po\u0161tu";
export const USER_LIKE = "Pridaj k ob\u013e\u00faben\u00fdm";
export const USER_UNLIKE = "Odober z ob\u013e\u00faben\u00fdch";
